import { initTiktokPixel, trackEventSingleTiktok } from '../tiktokPixel';
import { checkTrackingConversion, claimOrderEvent } from './helpers/util';
import tiktokPixelEvent from '../../data/tiktokPixelEvent';

function createTiktokEventObject(eventName, data) {
  const expectedParams = tiktokPixelEvent[eventName] || [];
  const eventData = {
    currency: data.currency || "IDR",
    content_type: data.content_type || "product",
  };

  for (const paramName of expectedParams) {
    if (paramName === 'content_id') {
      const contentIds = data.content_ids;
      if (Array.isArray(contentIds) && contentIds.length > 0) {
        eventData.content_id = String(contentIds[0]);
      } else if (contentIds && !Array.isArray(contentIds)) {
        eventData.content_id = String(contentIds);
      }
    } else if (data[paramName] !== undefined && data[paramName] !== null) {
      eventData[paramName] = data[paramName];
    }
  }
  return eventData;
}

export async function handleTikTokPixelTracking(tiktokTracking, data, globalConversionSetting) {
  for (const pixel of tiktokTracking) {
    const pixelId = pixel.pixelId || '';
    const shouldProcess = await checkTrackingConversion(
      pixel,
      `pixelsTiktok_${pixelId}`,
      globalConversionSetting,
      data.event_key
    );
    if (!shouldProcess) continue;

    // On an order page the pixel's automatic page view is an order event too: a reload must not repeat it
    initTiktokPixel(pixelId, claimOrderEvent('tiktok', pixelId, 'Pageview', data.event_key));
    if (pixel.pixelEvents && pixel.pixelEvents.length) {
      for (const event of pixel.pixelEvents) {
        if (event.name && pixel.enablePixelEvent && claimOrderEvent('tiktok', pixelId, event.name, data.event_key)) {
          const object = createTiktokEventObject(event.name, data);
          trackEventSingleTiktok(pixelId, event.name, object);
        }
      }
    }
  }
}
